import { FieldContainer } from "./styles";
import CpfCnpj from "@react-br-forms/cpf-cnpj-mask";

function InputCpfCnpj({ value, onChange, ...props }: any) {
  return (
    <FieldContainer fontSize={14} isInvalid={props.isInvalid}>
      <CpfCnpj
        value={value}
        onChange={(event: any) => {
          onChange(event.target.value);
        }}
        {...props}
        className="chakra-input"
      />
    </FieldContainer>
  );
}

export default InputCpfCnpj;
